module.exports = __webpack_public_path__ + "assets/images/airports/mobile.svg?v=0d9748f6";